import { render } from "./aboutUS.vue?vue&type=template&id=af40de30&scoped=true"
import script from "./aboutUS.vue?vue&type=script&lang=js"
export * from "./aboutUS.vue?vue&type=script&lang=js"

import "./aboutUS.vue?vue&type=style&index=0&id=af40de30&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-af40de30"]])

export default __exports__